/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import{signal as n}from"@lexical/extension/signals";function o(o,t={}){const i={};for(const r in o){const s=t[r],c=n(void 0===s?o[r]:s);i[r]=c}return i}export{o as namedSignals};
